var map = {
	"./aia.svg": 1401,
	"./ant.svg": 1402,
	"./aus.svg": 1403,
	"./bah.svg": 1404,
	"./ban.svg": 1405,
	"./bar.svg": 1406,
	"./ber.svg": 1407,
	"./biz.svg": 1408,
	"./bot.svg": 1409,
	"./bru.svg": 1410,
	"./can.svg": 1411,
	"./cay.svg": 1412,
	"./cmr.svg": 1413,
	"./cok.svg": 1414,
	"./cyp.svg": 1415,
	"./dma.svg": 1416,
	"./eng.svg": 1417,
	"./fij.svg": 1418,
	"./flk.svg": 1419,
	"./gab.svg": 1420,
	"./gam.svg": 1421,
	"./ggy.svg": 1422,
	"./gha.svg": 1423,
	"./gib.svg": 1424,
	"./grn.svg": 1425,
	"./guy.svg": 1426,
	"./ind.svg": 1427,
	"./iom.svg": 1428,
	"./ivb.svg": 1429,
	"./jam.svg": 1430,
	"./jey.svg": 1431,
	"./ken.svg": 1432,
	"./kir.svg": 1433,
	"./lca.svg": 1434,
	"./les.svg": 1435,
	"./manifest.json": 789,
	"./mas.svg": 1436,
	"./maw.svg": 1437,
	"./mdv.svg": 1438,
	"./mlt.svg": 1439,
	"./moz.svg": 1440,
	"./mri.svg": 1441,
	"./msr.svg": 1442,
	"./nam.svg": 1443,
	"./nfk.svg": 1444,
	"./ngr.svg": 1445,
	"./nir.svg": 1446,
	"./niu.svg": 1447,
	"./nru.svg": 1448,
	"./nzl.svg": 1449,
	"./pak.svg": 1450,
	"./png.svg": 1451,
	"./rsa.svg": 1452,
	"./rwa.svg": 1453,
	"./sam.svg": 1454,
	"./sco.svg": 1455,
	"./sey.svg": 1456,
	"./sgp.svg": 1457,
	"./shn.svg": 1458,
	"./skn.svg": 1459,
	"./sle.svg": 1460,
	"./sol.svg": 1461,
	"./sri.svg": 1462,
	"./svg-country.svg": 1463,
	"./swz.svg": 1464,
	"./tan.svg": 1465,
	"./tca.svg": 1466,
	"./tga.svg": 1467,
	"./tog.svg": 1468,
	"./tto.svg": 1469,
	"./tuv.svg": 1470,
	"./uga.svg": 1471,
	"./van.svg": 1472,
	"./wal.svg": 1473,
	"./zam.svg": 1474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1400;